export type MapPointScope = 'personal' | 'organization';

const STORAGE_KEY = 'saipol.mapPointScope';

export function readMapPointScope(): MapPointScope {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'organization'
      ? 'organization'
      : 'personal';
  } catch {
    return 'personal';
  }
}

export function writeMapPointScope(scope: MapPointScope) {
  try {
    localStorage.setItem(STORAGE_KEY, scope);
  } catch {
    // Private mode or a full storage must not block the map.
  }
}

export function resolveMapPointScope(scope?: string | null): MapPointScope {
  if (scope === 'organization' || scope === 'personal') {
    return scope;
  }
  return readMapPointScope();
}
